import { render } from "./CryptoWallet.vue?vue&type=template&id=1ad9f514&scoped=true"
import script from "./CryptoWallet.vue?vue&type=script&lang=js"
export * from "./CryptoWallet.vue?vue&type=script&lang=js"

import "./CryptoWallet.vue?vue&type=style&index=0&id=1ad9f514&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad9f514"]])

export default __exports__